export { MorphemeMnemonicsPronunciationViewTab } from "#morpheme-mnemonics-pronunciation-view-tab";
